var _mask, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoungedetail(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_556_9927",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37257 5.37258 0 12 0H115.985C122.612 0 127.985 5.37258 127.985 12V115.985C127.985 122.612 122.612 127.985 115.985 127.985H12C5.37257 127.985 0 122.612 0 115.985V12Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37257 5.37258 0 12 0H115.985C122.612 0 127.985 5.37258 127.985 12V115.985C127.985 122.612 122.612 127.985 115.985 127.985H12C5.37257 127.985 0 122.612 0 115.985V12Z",
    fill: "#F5F3FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 0V1.27467H115.985V0V-1.27467H12V0ZM127.985 12H126.71V115.985H127.985H129.259V12H127.985ZM115.985 127.985V126.71H12V127.985V129.259H115.985V127.985ZM0 115.985H1.27467V12H0H-1.27467V115.985H0ZM12 127.985V126.71C6.07656 126.71 1.27467 121.908 1.27467 115.985H0H-1.27467C-1.27467 123.316 4.66859 129.259 12 129.259V127.985ZM127.985 115.985H126.71C126.71 121.908 121.908 126.71 115.985 126.71V127.985V129.259C123.316 129.259 129.259 123.316 129.259 115.985H127.985ZM115.985 0V1.27467C121.908 1.27467 126.71 6.07656 126.71 12H127.985H129.259C129.259 4.6686 123.316 -1.27467 115.985 -1.27467V0ZM12 0V-1.27467C4.6686 -1.27467 -1.27467 4.66859 -1.27467 12H0H1.27467C1.27467 6.07656 6.07656 1.27467 12 1.27467V0Z",
    fill: "#EDE9FE",
    mask: "url(#path-1-inside-1_556_9927)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6592 37.3281V42.6608",
    stroke: "#C4B4FF",
    strokeWidth: 5.33269,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3252 37.3281V42.6608",
    stroke: "#C4B4FF",
    strokeWidth: 5.33269,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6576 53.3262C75.3648 53.3262 76.043 53.6071 76.543 54.1071C77.043 54.6072 77.324 55.2854 77.324 55.9925V77.3233C77.324 80.1519 76.2003 82.8647 74.2001 84.8648C72.2 86.865 69.4872 87.9887 66.6586 87.9887H50.6605C47.8319 87.9887 45.1191 86.865 43.1189 84.8648C41.1188 82.8647 39.9951 80.1519 39.9951 77.3233V55.9925C39.9951 55.2854 40.276 54.6072 40.7761 54.1071C41.2761 53.6071 41.9543 53.3262 42.6615 53.3262H79.9903C82.8189 53.3262 85.5317 54.4498 87.5319 56.45C89.532 58.4501 90.6557 61.1629 90.6557 63.9916C90.6557 66.8202 89.532 69.533 87.5319 71.5331C85.5317 73.5333 82.8189 74.6569 79.9903 74.6569H77.324",
    stroke: "#C4B4FF",
    strokeWidth: 5.33269,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9941 37.3281V42.6608",
    stroke: "#C4B4FF",
    strokeWidth: 5.33269,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoungedetail);
export default __webpack_public_path__ + "static/media/loungedetail.b269a808d92d85792480c645fb90160d.svg";
export { ForwardRef as ReactComponent };